import React from 'react';
// logic
import useTicketFormSettings from '../components/ticket-form/use-ticket-form-settings';
// components
import { Spacer } from '@ontruck/orc';
import PortalContent from '../ui/portal/portal-content';
import NewTicketToolbar from '../components/ticket-form/new-ticket-toolbar';
import LoadSpinner from 'components/LoadSpinner';
import useNewTicket from '../components/ticket-form/use-new-ticket';
import TicketForm from '../components/ticket-form/ticket-form';
import TicketConfirmation from '../components/ticket-confirmation/ticket-confirmation';

const NewTicketPage = () => {
  const { isLoadingTicketFormSettings, ticketFormSettings } =
    useTicketFormSettings();

  const {
    newTicketInternalId,
    createdTicket,
    onSubmit,
    onCancel,
    reset,
    validationSchema,
    initialValues,
    isReadOnly,
    isEdit,
    showConfirmation,
  } = useNewTicket();

  const ticketFormData = {
    createdTicket,
    ticketFormSettings,
    validationSchema,
    initialValues,
    isReadOnly,
    isEdit,
    onSubmit,
    onCancel,
    reset,
  };

  return (
    <>
      <PortalContent>
        <NewTicketToolbar />
      </PortalContent>
      {isLoadingTicketFormSettings ? (
        <Spacer pTop="L" pBottom="L">
          <LoadSpinner />
        </Spacer>
      ) : showConfirmation ? (
        <TicketConfirmation ticketFormData={ticketFormData} />
      ) : (
        <TicketForm key={newTicketInternalId} ticketFormData={ticketFormData} />
      )}
    </>
  );
};

export default NewTicketPage;
